/* JOUVANA PARIS — English version of the custom product-page blocks (loaded only when the site is in English)
   Never touches <select>/<option> : the variant picker compares option text with its value. */
(function () {
  var PHRASES = [
    ["Vous voulez porter un pull épais en dessous, ou vous hésitez entre deux tailles ? Choisissez la taille supérieure.", "Want to wear a thick jumper underneath, or between two sizes? Choose the larger size."],
    ["Entre deux tailles ? Pour plus d'aisance à la taille, choisissez la taille supérieure.", "Between two sizes? For a more comfortable waist, choose the larger size."],
    ["Entre deux tailles ? Pour plus d'aisance à la taille, privilégiez la taille supérieure.", "Between two sizes? For a more comfortable waist, choose the larger size."],
    ["Entre deux tailles ? Pour une coupe plus fluide, choisissez la taille supérieure.", "Between two sizes? For a looser fit, choose the larger size."],
    ["Entre deux tailles ou coupe fluide préférée ? Choisissez la taille supérieure.", "Between two sizes or prefer a looser fit? Choose the larger size."],
    ["Entre deux tailles ? Choisissez la taille supérieure.", "Between two sizes? Choose the larger size."],
    ["Entre deux pointures ? Choisissez la pointure supérieure.", "Between two sizes? Choose the larger size."],
    ["posez le pied sur une feuille, marquez le talon et le plus long orteil, puis mesurez la distance.", "place your foot on a sheet of paper, mark the heel and the longest toe, then measure the distance."],
    ["Correspondance des pointures, longueur du pied en centimètres.", "Size conversion, foot length in centimetres."],
    ["Mesures du corps données à titre indicatif, en centimètres.", "Body measurements for guidance only, in centimetres."],
    ["Mesures données à titre indicatif, en centimètres.", "Measurements for guidance only, in centimetres."],
    ["de l'entrejambe jusqu'à la cheville, à l'intérieur de la jambe.", "from crotch to ankle, along the inside of the leg."],
    ["mesurez la partie la plus fine de la taille.", "measure the narrowest part of your waist."],
    ["mesurez la partie la plus large du bassin.", "measure the widest part of your hips."],
    ["partie la plus forte, bras le long du corps.", "fullest part, arms relaxed."],
    ["partie la plus forte de la poitrine.", "fullest part of your bust."],
    ["partie la plus fine de la taille.", "narrowest part of your waist."],
    ["partie la plus large du bassin.", "widest part of your hips."],
    ["partie la plus fine.", "narrowest part."],
    ["de l'entrejambe à la cheville.", "from crotch to ankle."],
    ["Livraison en 5 à 10 jours ouvrés", "Delivery in 5 to 10 business days"],
    ["Retour garanti sous 30 jours", "30-day return guarantee"],
    ["GUIDE DES TAILLES · PANTALONS", "SIZE GUIDE · TROUSERS"],
    ["TABLEAU DES TAILLES", "SIZE CHART"],
    ["Tableau des tailles", "Size chart"],
    ["Guide des tailles", "Size guide"],
    ["Paiement 100 % sécurisé", "100% secure payment"],
    ["Ajouté au panier", "Added to cart"],
    ["Notre modèle mesure", "Our model is"],
    ["et porte une taille", "and wears a size"],
    ["Comment mesurer :", "How to measure:"],
    ["Tour de taille :", "Waist:"],
    ["Hanches :", "Hips:"],
    ["Entrejambe :", "Inseam:"],
    ["Poitrine :", "Bust:"],
    ["Expédié le", "Ships on"]
  ];
  var EXACT = {
    "Taille": "Size", "Tour de taille": "Waist", "Hanches": "Hips", "Entrejambe": "Inseam", "Poitrine": "Bust",
    "Pointure EU": "EU size", "Pied (cm)": "Foot (cm)",
    "Noir": "Black", "Blanc": "White", "Marron": "Brown", "Gris": "Grey", "Rose": "Pink",
    "Rouge": "Red", "Bordeaux": "Burgundy", "Marine": "Navy", "Bleu marine": "Navy", "Bleu": "Blue",
    "Bleu ciel": "Sky blue", "Vert": "Green", "Kaki": "Khaki", "Jaune": "Yellow", "Écru": "Ecru",
    "Crème": "Cream", "Chocolat": "Chocolate", "Léopard": "Leopard", "Doré": "Gold", "Argent": "Silver",
    "Violet": "Purple", "Gris clair": "Light grey",
    "Gris foncé": "Dark grey", "Marron foncé": "Dark brown", "Vieux rose": "Dusty pink", "Moutarde": "Mustard"
  };
  var STOCK = /Plus que\s+(\d+)\s+en stock\s*!/;
  var SKIP = /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|SELECT|OPTION|OPTGROUP|INPUT)$/;

  function inPicker(node) {
    var p = node.parentNode;
    while (p && p.nodeType === 1) {
      if (SKIP.test(p.nodeName)) return true;
      p = p.parentNode;
    }
    return false;
  }

  function shipDate() {
    var parts = {};
    new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/Paris", year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", hourCycle: "h23" })
      .formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; });
    var d = new Date(Date.UTC(+parts.year, +parts.month - 1, +parts.day, 12));
    d.setUTCDate(d.getUTCDate() + ((+parts.hour >= 23) ? 2 : 1));
    if (d.getUTCDay() === 0) d.setUTCDate(d.getUTCDate() + 1);
    return d.toLocaleDateString("en-GB", { weekday: "short", day: "numeric", month: "short", timeZone: "UTC" });
  }

  function fixText(node) {
    var v = node.nodeValue;
    if (!v || !/[A-Za-zÀ-ÿ]/.test(v) || inPicker(node)) return;
    var t = v.trim();
    if (EXACT.hasOwnProperty(t)) { node.nodeValue = v.replace(t, EXACT[t]); return; }
    var out = v;
    for (var i = 0; i < PHRASES.length; i++) {
      if (out.indexOf(PHRASES[i][0]) !== -1) out = out.split(PHRASES[i][0]).join(PHRASES[i][1]);
    }
    out = out.replace(STOCK, function (m, n) { return "Only " + n + " left in stock!"; });
    if (out !== v) node.nodeValue = out;
  }

  function fixAttrs(el) {
    if (!el.getAttribute || SKIP.test(el.nodeName)) return;
    ["title", "aria-label"].forEach(function (a) {
      var v = el.getAttribute(a);
      if (!v) return;
      var parts = v.split(" "), last = parts.pop();
      var tr = EXACT[v] || (EXACT[last] ? parts.concat(EXACT[last]).join(" ") : null);
      if (tr && tr !== v) el.setAttribute(a, tr);
    });
  }

  function walk(root) {
    if (!root) return;
    if (root.nodeType === 3) { fixText(root); return; }
    if (root.nodeType === 11) { var fk = root.childNodes; for (var j = 0; j < fk.length; j++) walk(fk[j]); return; }
    if (root.nodeType !== 1 || SKIP.test(root.nodeName)) return;
    if (root.tagName === "TEMPLATE") { walk(root.content); return; }
    fixAttrs(root);
    if (root.classList && root.classList.contains("jvn-ship__date") && !root.dataset.jvnEn) {
      root.dataset.jvnEn = "1"; root.textContent = shipDate();
    }
    var kids = root.childNodes;
    for (var i = 0; i < kids.length; i++) walk(kids[i]);
  }

  var css = document.createElement("style");
  css.textContent =
    ".related-products .related-products__heading{font-size:0!important}" +
    ".related-products .related-products__heading::after{display:none!important}" +
    ".related-products .related-products__heading::before{content:'You may also like'!important;width:auto!important;height:auto!important;flex:0 0 auto!important;" +
    "background:linear-gradient(#111,#111) left center/58px 2px no-repeat,linear-gradient(#111,#111) right center/58px 2px no-repeat!important;" +
    "padding:0 80px!important;font-size:21px!important;line-height:1.3;color:#111;font-family:'Marcellus','Times New Roman',Georgia,serif}" +
    "@media screen and (min-width:750px){.related-products .related-products__heading::before{font-size:28px!important;padding:0 112px!important;" +
    "background-size:90px 2px,90px 2px!important}}";
  (document.head || document.documentElement).appendChild(css);

  function start() {
    document.querySelectorAll("template").forEach(function (t) { walk(t.content); });
    walk(document.body);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.type === "characterData") fixText(m.target);
        else if (m.type === "attributes") fixAttrs(m.target);
        else m.addedNodes.forEach(walk);
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ["title", "aria-label"] });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})();
